<ion-header>
  <ion-toolbar>
    <ion-title>Selecciona el grupo</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="6" *ngFor="let item of buttons">
        <ion-card class="custom-card">
          <ion-card-header>
            <!-- <ion-icon [name]="item.icon" class="card-icon"></ion-icon> -->
            <ion-card-title [ngStyle]="{ color: item.color_button }">{{
              item.name
            }}</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <p style="color: black">
              {{ item.description }}
            </p>

            <ion-badge
              (click)="openModal(item.id, item)"
              [ngStyle]="{
                color: getTextColor(item.color_button),
                'background-color': item.color_button
                  ? item.color_button
                  : 'var(--ion-color-primary)'
              }"
              >{{
                item.text_button
                  ? (item.text_button | titlecase)
                  : "Registrarme"
              }}</ion-badge
            >
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<!-- <ion-content class="ion-padding">
  <ion-list>
    <ion-item *ngFor="let button of buttons">
      <ion-label>
        <h2>{{ button.name }}</h2>
        <p>{{ button.description }}</p>
        <p
          *ngIf="button.text_button"
          (click)="saveRol(button.id)"
          style="color: green; font-weight: bold"
        >
          {{ button.text_button ? button.text_button : "REGISTRAR" }}
        </p>
        <a *ngIf="button.tyc" [href]="button.tyc" target="_blank">Ver TyC</a>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content> -->

<!-- <ion-footer>
  <ion-toolbar>
    <ion-button expand="full" (click)="close()">Cerrar</ion-button>
  </ion-toolbar>
</ion-footer> -->
